import React from 'react';
import Lines from '../../containers/Lines/Lines';

const LinesPage = () => {
  return <Lines />;
};

export default LinesPage;
